import React from 'react';
import useReviewFromPastCustomerPageData from './useReviewFromPastCustomerPageData';
import CustomerDetails from './components/CustomerDetails/CustomerDetails';
import ReviewForm from './components/ReviewForm/ReviewForm';

interface IReviewFromPastCustomerPageProps {}

const ReviewFromPastCustomerPage: React.FC<React.PropsWithChildren<IReviewFromPastCustomerPageProps>> =
  ({}) => {
    const {
      handleSubmitCustomerDetails,
      providerDetails,
      reviewId,
      customerDetails,
      handleCustomerDetailsChange,
      formFields,
      customer,
      provider,
      handleSubmit,
      saveData,
      submittedMsg,
    } = useReviewFromPastCustomerPageData();

    return (
      <div className="flex flex-col w-screen h-screen py-12 overflow-y-auto bg-gray-100">
        <div className="flex flex-col w-full">
          {!reviewId && (
            <CustomerDetails
              customerDetails={customerDetails}
              providerDetails={providerDetails}
              onChange={handleCustomerDetailsChange}
              onSubmit={handleSubmitCustomerDetails}
            />
          )}
          {!!reviewId && (
            <ReviewForm
              formFields={formFields}
              provider={provider}
              customer={customer}
              onSave={saveData}
              onSubmit={handleSubmit}
              submittedMsg={submittedMsg}
            />
          )}
        </div>
      </div>
    );
  };
export default ReviewFromPastCustomerPage;
